import React from 'react';
import cn from 'classnames';

import Box, { BoxProps } from '../Box';
import { ScrollableProps } from './types';

const Scrollable = React.forwardRef<HTMLDivElement, ScrollableProps>(({ ...props }, ref) => {
  const { contentContainerClassName, horizontal, showsHorizontalScrollIndicator, ...rest } = props;
  return (
    <Box
      ref={ref}
      {...(rest as BoxProps)}
      className={cn(rest.className, contentContainerClassName)}
    />
  );
});

export default Scrollable;
